import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Passenger, PnrInfo, SearchForm } from 'src/app/core/models/itinerary.model';
import { ContractError, StepMiniState } from 'src/app/core/models/models';
import * as ReRouteActions from '../store/actions/re-route.actions';
import { GenericError } from 'src/app/layout/actions/layout.actions';
import { DOCSADoc } from 'src/app/core/models/docsa.model';
import {
  IReRouteModalQuote,
  IReRouteQuoteRequest,
  IRerouteUpdateQuoteRequest
} from 'src/app/core/models/re-route.model';
import {
  ReRouteState,
  selectLoading,
  selectIsError,
  selectError,
  selectModalQuote,
  selectQuoteRequest,
  selectStepsState,
  selectDocsaDocs,
  selectPnrInfo,
  selectSelectedPassengers
} from '../store/reducers/re-route.reducer';

@Injectable()
export class ReRouteService {
  constructor(private store: Store<ReRouteState>, private router: Router) {}

  getLoading(): Observable<boolean> {
    return this.store.pipe(select(selectLoading));
  }

  getPnrInfo(): Observable<PnrInfo> {
    return this.store.pipe(select(selectPnrInfo));
  }

  getSelectedPassengers(): Observable<Passenger[]> {
    return this.store.pipe(select(selectSelectedPassengers));
  }

  getIsError(): Observable<boolean> {
    return this.store.pipe(select(selectIsError));
  }

  getError(): Observable<ContractError> {
    return this.store.pipe(select(selectError));
  }

  getModalQuote(): Observable<IReRouteModalQuote> {
    return this.store.pipe(select(selectModalQuote));
  }

  getQuoteRequest(): Observable<IReRouteQuoteRequest> {
    return this.store.pipe(select(selectQuoteRequest));
  }

  getStepsState(): Observable<StepMiniState> {
    return this.store.pipe(select(selectStepsState));
  }

  getDocsaDocs(): Observable<DOCSADoc[]> {
    return this.store.pipe(select(selectDocsaDocs));
  }

  dispatchSaveLoadingState(isLoading: boolean) {
    this.store.dispatch(ReRouteActions.updateLoading({ isLoading }));
  }

  dispatchSaveStepState(step: StepMiniState) {
    this.store.dispatch(ReRouteActions.saveStepsState({ step: step }));
  }

  dispatchSaveModalQuote(reRouteModalQuote: IReRouteModalQuote) {
    this.store.dispatch(ReRouteActions.saveReRouteModalQuote({ reRouteModalQuote }));
  }

  dispatchSaveReRouteQuoterequest(reRouteQuoteRequest: IReRouteQuoteRequest) {
    this.store.dispatch(ReRouteActions.saveReRouteQuoteRequest({ reRouteQuoteRequest }));
  }

  dispatchSaveSelectedPassengers(selectedPassengers: Passenger[]) {
    this.store.dispatch(ReRouteActions.saveSelectedPassengers({ selectedPassengers }));
  }

  dispatchResetReRouteState() {
    this.store.dispatch(ReRouteActions.resetReRouteState());
  }

  dispatchReviewInitialtate() {
    this.store.dispatch(ReRouteActions.reRouteInitialStep());
  }

  dispatchUpdateReRouteQuoteRequest(updatedData: IRerouteUpdateQuoteRequest) {
    this.store.dispatch(ReRouteActions.updateReRouteQuoteRequest({ updatedData }));
  }

  dispatchReRouteQuoteRequest(reRouteQuoteRequest: IReRouteQuoteRequest) {
    this.store.dispatch(ReRouteActions.ForceRefreshSesionAndReRoute({ reRouteQuoteRequest }));
  }

  dispatchReRouteFail(error: ContractError) {
    this.store.dispatch(GenericError({ error, titleKey: 'error' }));
  }

  navigateToPnrInfo(searchForm: SearchForm) {
    this.router.navigate(['/itinerary/info'], {
      queryParams: { ...searchForm }
    });
  }

  dispatchSaveDocsa(docs: DOCSADoc[]) {
    this.store.dispatch(ReRouteActions.DocsaSave({ docs }));
  }

  dispatchSetReceivedFrom(receivedFrom: string) {
    this.store.dispatch(ReRouteActions.SetReceivedFrom({ receivedFrom }));
  }

  dispatchRemoveReceivedFrom(): void {
    this.store.dispatch(ReRouteActions.RemoveReceivedFrom());
  }
}
